import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { Fuel } from "lucide-react";

import { useTranslation } from "react-i18next";
export default function ForgotPassword() {
  const { t } = useTranslation();
  const [phone, setPhone] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/password-reset/request", { phone: phone.trim() });
      setSent(true);
      toast.success(t("auth.forgotpassword.if_your_account_exists_a_reset_link_has"));
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-lg bg-amber-500 text-2xl font-black text-white">
            <Fuel className="h-7 w-7" />
          </div>
          <div className="text-2xl font-bold text-foreground">{t("auth.forgotpassword.reset_password")}</div>
        </div>
        <Card className="border-border">
          <CardHeader>
            <CardTitle className="text-lg">{t("auth.forgotpassword.forgot_your_password")}</CardTitle>
            <p className="text-xs text-muted-foreground">{t("auth.forgotpassword.enter_your_registered_phone_we_ll_send_a")} <b>email</b> and via <b>{t("auth.forgotpassword.whatsapp")}</b> (valid 30 minutes).</p>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="phone">{t("dealer.phone")}</Label>
                <Input id="phone" inputMode="numeric" value={phone} onChange={(e) => setPhone(e.target.value)}
                       placeholder="10-digit phone" data-testid="forgot-phone"
                       className="h-11 text-base md:h-9 md:text-sm" required />
              </div>
              <Button type="submit" className="h-11 w-full md:h-10" disabled={submitting || sent} data-testid="forgot-submit">
                {submitting ? "Sending…" : sent ? "Sent — check email + WhatsApp" : "Send reset link"}
              </Button>
            </form>
            {sent && (
              <div className="mt-3 rounded-lg border border-amber-300 bg-amber-50/60 p-3 text-[11px] text-amber-900 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-200">
                Didn't get anything in 2 minutes? Check spam, then{" "}
                <a
                  href="https://wa.me/917024045401?text=Hi%20HisabX%2C%20I%20need%20help%20resetting%20my%20password.%20My%20phone%3A%20"
                  target="_blank" rel="noopener noreferrer"
                  className="font-bold underline"
                  data-testid="forgot-whatsapp-support"
                >{t("auth.forgotpassword.whatsapp_us")}</a> for a manual reset.
              </div>
            )}
            <div className="mt-4 text-center text-xs text-muted-foreground">
              <Link to="/login" className="font-semibold text-amber-600 hover:underline" data-testid="link-back-login">{t("auth.forgotpassword.back_to_sign_in")}</Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
